module.exports = __webpack_public_path__ + "img/sport_badminton.820b07d2.png";